import { RootState } from 'store'

export const version = (state: RootState) => state.version
